import { SVGProps } from './types';

const PylonIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    fill="none"
    viewBox="0 0 407 407"
    {...props}
  >
    <path
      fill="currentColor"
      d="M347.435 59.596C309.006 21.167 257.883 0 203.516 0S97.994 21.167 59.596 59.596C21.167 98.026 0 149.117 0 203.484s21.167 105.491 59.565 143.92C97.994 385.833 149.117 407 203.484 407s105.491-21.167 143.92-59.596S407 257.883 407 203.516s-21.167-105.49-59.565-143.92M183.167 183.388H41.894a161.8 161.8 0 0 1 10.331-40.193h130.942zM41.925 224.022h141.242v40.193H52.415c-5.103-12.695-8.694-26.176-10.458-40.193zM183.167 41.925v60.636H75.818c25.893-32.665 64.007-55.186 107.381-60.636zM76.133 304.88h107.034v60.226c-43.185-5.386-81.173-27.782-107.034-60.226m147.7 60.195V41.925c80.228 10.049 142.533 78.685 142.533 161.591 0 82.905-62.274 151.542-142.533 161.559"
    ></path>
  </svg>
);

export { PylonIcon };
